var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-3 -3 93 93",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1.15) translate(-6 -6)",
    d: "M43.54 8.21        C45.04 8.16, 53.12 21.94, 54.34 22.82        C55.65 23.77, 72.56 28.90, 73.12 30.42        C73.63 31.83, 63.33 44.72, 62.86 46.15        C62.36 47.69, 62.71 65.36, 61.43 66.36        C60.25 67.29, 44.81 61.48, 43.31 61.48        C41.69 61.48, 24.99 67.27, 23.64 66.36        C22.39 65.52, 23.14 49.04, 22.68 47.61        C22.18 46.07, 11.52 31.98, 11.96 30.42        C12.37 28.98, 28.28 24.60, 29.49 23.72        C30.80 22.77, 40.91 8.27, 42.53 8.21        Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar5);
export default __webpack_public_path__ + "static/media/star5.5367815ca9453fe42543551f30541e1a.svg";
export { ForwardRef as ReactComponent };